import clsx from 'clsx';
import { FC, forwardRef, useState } from 'react';

import ErrorMessage from '@/components/forms/ErrorMessage';
import HidePasswordIcon from '@/components/icons/HidePasswordIcon';
import ShowPasswordIcon from '@/components/icons/ShowPasswordIcon';

interface Props {
  name: string;
  id?: string;
  classNameContainer?: string;
  labelText: string;
  customClasses?: string;
  otherProps?: any;
  autoComplete?: string;
  placeholder?: string;
  error?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  wrapErrorText?: boolean;
}

export const PasswordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^\s]{8,}$/;

export const PasswordInput: FC<Props> = forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      id = '',
      classNameContainer = '',
      customClasses = '',
      labelText = '',
      otherProps,
      autoComplete,
      placeholder,
      error,
      value,
      onChange,
      wrapErrorText = false,
    },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
      <div className={clsx('relative mb-0.5 pb-3.5 md:mb-1 md:pb-5.5', classNameContainer)}>
        <label htmlFor={id} className="text-second-accent text-input-label mb-1 w-fit">
          {labelText}
        </label>
        <div className="relative">
          <input
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            autoComplete={autoComplete}
            type={showPassword ? 'text' : 'password'}
            placeholder={placeholder}
            {...otherProps}
            className={clsx(
              'text-input-mobile border-secondary-stroke w-full rounded-md border-[1px] border-solid px-3 py-2 text-black',
              customClasses,
            )}
          />
          <div
            className="absolute top-1 right-1 flex h-[36px] w-[30px] cursor-pointer items-center justify-center"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <HidePasswordIcon /> : <ShowPasswordIcon />}
          </div>
        </div>
        {!!error && <ErrorMessage message={error} wrapText={wrapErrorText} />}
      </div>
    );
  },
);
